import { render, staticRenderFns } from "./PhoneInfoModal.vue?vue&type=template&id=278b433a&scoped=true"
import script from "./PhoneInfoModal.vue?vue&type=script&lang=ts"
export * from "./PhoneInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278b433a",
  null
  
)

export default component.exports